<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="550" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="h6">
					<span class="primary--text text-uppercase font-weight-bold">Opsi Pengiriman</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<div class="py-2"><v-divider></v-divider></div>
					<v-row v-if="showPickupStore">
						<v-col cols="12" class="pb-0">
							<div class="text-body-1 font-weight-bold pb-1">Ambil Di Toko</div>
							<v-radio-group class="mt-0" v-model="selectedCour">
								<div>
									<v-radio label="Ambil Di Toko" value="pick_up" class="small-check mt-0"></v-radio>
									<v-row class="px-5 text-body-2 grey--text text--darken-3">
										<v-col md="4" class="py-0 pl-5">
											<v-img width="40" src="/assets/icons/market-icon.svg"></v-img>
										</v-col>
										<v-col md="8" class="py-0 text-right font-weight-bold my-auto">Rp 0</v-col>
									</v-row>
								</div>
							</v-radio-group>
						</v-col>
					</v-row>
					<v-row align="center" justify="center">
						<v-col cols="12" v-if="ongkirSample.length > 0">
							<div class="text-body-1 font-weight-bold pb-1">Jasa Kurir</div>
							<v-radio-group class="mt-0" v-model="selectedCour">
								<div class="pb-4" v-for="(cour, index) in ongkirSample" :key="index">
									<v-radio :value="cour" class="small-check mt-0">
										<template slot="label">
											<v-row class="px-3 text-body-2 grey--text text--darken-3">
												<v-col sm="2" md="2" class="py-0 my-auto">
													<v-img width="60" :src="'/assets/courier/'+cour.code.toLowerCase()+'.svg'"></v-img>
												</v-col>
												<v-col sm="6" md="6" class="py-0 font-weight-bold my-auto">
													{{cour.description}}
												</v-col>
												<v-col sm="4" md="4" class="py-0 text-right font-weight-bold my-auto">
													{{cour.etd ? cour.etd : '-'}}
												</v-col>
												<v-col sm="12" md="12" class="py-0 text-right font-weight-bold my-auto">Rp {{cour.cost | toNumber}}</v-col>
											</v-row>
										</template>
									</v-radio>
								</div>
							</v-radio-group>
						</v-col>
						<v-col cols="12" v-else>
							<div class="text-body-1 font-weight-bold pb-1">Jasa Kurir</div>
							<div class="text-center">Mohon maaf saat ini tidak ada kurir yang tersedia</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="pt-0">
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="pilihCour" depressed class="text-capitalize font-weight-bold rounded-lg" height="45" width="150">Pilih</v-btn>
					<!-- <v-btn @click="modalHide" color="primary" depressed class="text-capitalize font-weight-bold rounded-lg" height="45" width="150">Tutup</v-btn> -->
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			selectedCour: {},
			dialog: false,
			ongkirSample: [
				{
					code: 'jne',
					name: 'Jalur Nugraha Ekakurir (JNE)',
					service: 'OKE',
					description: 'Ongkos Kirim Ekonomis',
					cost: 39000,
					etd: '3-4 Hari',
					note: ''
				},
				{
					code: 'jne',
					name: 'Jalur Nugraha Ekakurir (JNE)',
					service: 'REG',
					description: 'Layanan Reguler',
					cost: 43000,
					etd: '2-3 Hari',
					note: ''
				},
				{
					code: 'tiki',
					name: 'Citra Van Titipan Kilat (TIKI)',
					service: 'REG',
					description: 'Regular Service',
					cost: 41000,
					etd: '4 Hari',
					note: ''
				},
				{
					code: 'pos',
					name: 'POS Indonesia (POS)',
					service: 'Pos Reguler',
					description: 'Pos Reguler',
					cost: 43000,
					etd: '4 Hari',
					note: ''
				},
				{
					code: 'J&T',
					name: 'J&T Express',
					service: 'EZ',
					description: 'Regular Service',
					cost: 38000,
					etd: '',
					note: ''
				}
			]
		}
	},
	props: {
		showPickupStore:{
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapState('options', ['ongkir']),
	},
	methods: {
		modalShow(cour) {
			this.dialog = true
			this.selectedCour = cour
		},
		modalHide() {
			this.dialog = false
		},
		pilihCour() {
			this.$emit('action', this.selectedCour)
			this.modalHide()
		}
	}
};
</script>